function readEnv(value: string | undefined, fallback: string): string {
  const normalized = value?.trim()
  return normalized || fallback
}

export const appConfig = Object.freeze({
  title: readEnv(import.meta.env.VITE_APP_TITLE, '鲟途平台'),
  apiBaseUrl: readEnv(import.meta.env.VITE_API_BASE_URL, '/api'),
})
